module.exports = __webpack_public_path__ + "img/ug.ugac0f0d7.svg";